// Inicialização do sidebar para AdminLTE 2.4.18
let sidebarReady = false;

export const initSidebar = () => {
  // Aguarda o DOM estar pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSidebar);
  } else {
    setupSidebar();
  }
};

function setupSidebar() {
  if (sidebarReady) return;
  sidebarReady = true;

  const $ = window.$;

  if (!$) {
    console.error('jQuery não encontrado');
    return;
  }

  let treeInitialized = false;

  const initTreeview = () => {
    if (treeInitialized) return true;
    const $menus = $('.sidebar-menu');
    if (!$menus || $menus.length === 0) return false;

    // Submenus são React (MenuTree) — plugin tree do AdminLTE conflita com estado React
    if ($menus.find('[data-react-treeview]').length > 0) {
      treeInitialized = true;
      return true;
    }

    try {
      if ($.fn && typeof $.fn.tree === 'function') {
        $menus.tree();
        treeInitialized = true;
        return true;
      }
      if ($.AdminLTE && typeof $.AdminLTE.tree === 'function') {
        $.AdminLTE.tree('.sidebar-menu');
        treeInitialized = true;
        return true;
      }
    } catch (_) {}

    return false;
  };

  // Força a inicialização do AdminLTE
  if ($.AdminLTE && $.AdminLTE.layout) {
    $.AdminLTE.layout.activate();
  }

  initTreeview();

  let tries = 0;
  const retry = () => {
    tries += 1;
    if (initTreeview() || tries >= 20) return;
    setTimeout(retry, 250);
  };
  setTimeout(retry, 250);

  try {
    const target = document.querySelector('.main-sidebar');
    if (target && typeof MutationObserver !== 'undefined') {
      const obs = new MutationObserver(() => {
        if (initTreeview()) obs.disconnect();
      });
      obs.observe(target, { childList: true, subtree: true });
    }
  } catch (_) {}

  // Submenus React (MenuTree) controlam abertura via estado — não fechar via jQuery
  // ao navegar, senão React fica dessincronizado (duplo clique no pai).
  $(document).on('click', '.sidebar-menu .treeview-menu a', function(e) {
    e.stopPropagation();
  });

  // Flag para evitar que touch e click disparem juntos
  let touchHandled = false;
  // Flag para prevenir fechamento imediato após abrir
  let justOpened = false;

  // Função compartilhada para toggle do sidebar
  const toggleSidebar = function() {
    const wasCollapsed = $('body').hasClass('sidebar-collapse');
    $('body').toggleClass('sidebar-collapse');
    const isCollapsed = $('body').hasClass('sidebar-collapse');
    localStorage.setItem('sidebar-collapsed', isCollapsed);
    $(window).trigger('resize');

    // Se acabou de abrir, marca a flag para prevenir fechamento imediato
    if (wasCollapsed && !isCollapsed) {
      justOpened = true;
      setTimeout(function() {
        justOpened = false;
      }, 300);
    }
  };

  // Configura o toggle do sidebar manualmente
  $(document).on('click', '.sidebar-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();

    // Se touch foi usado recentemente, ignora o click
    if (touchHandled) {
      touchHandled = false;
      return;
    }

    toggleSidebar();
  });

  // Suporte para touch events em dispositivos móveis
  // Usa touchend ao invés de touchstart para evitar problemas com passive listeners
  $(document).on('touchend', '.sidebar-toggle', function(e) {
    e.stopPropagation();

    // Marca que touch foi usado para evitar que click também dispare
    touchHandled = true;

    // Reset da flag após um curto delay
    setTimeout(function() {
      touchHandled = false;
    }, 500);

    toggleSidebar();
  });

  // Restaura o estado do sidebar ao carregar
  // No mobile, sempre inicia colapsado
  const isMobile = window.innerWidth <= 767;
  if (isMobile) {
    $('body').addClass('sidebar-collapse');
  } else {
    const savedState = localStorage.getItem('sidebar-collapsed');
    if (savedState === 'true') {
      $('body').addClass('sidebar-collapse');
    }
  }

  // Fechar sidebar ao clicar no overlay (mobile apenas)
  $(document).on('click', function(e) {
    if (window.innerWidth <= 767) {
      // Não fecha se acabou de abrir
      if (justOpened) {
        return;
      }

      const $target = $(e.target);
      const isClickInsideSidebar = $target.closest('.main-sidebar').length > 0;
      const isClickOnToggle = $target.closest('.sidebar-toggle').length > 0;
      const isClickOnNavbar = $target.closest('.main-header').length > 0;
      const isSidebarOpen = !$('body').hasClass('sidebar-collapse');

      // Se clicou fora do sidebar/navbar e o sidebar está aberto, fecha
      if (isSidebarOpen && !isClickInsideSidebar && !isClickOnToggle && !isClickOnNavbar) {
        $('body').addClass('sidebar-collapse');
        localStorage.setItem('sidebar-collapsed', true);
        $(window).trigger('resize');
      }
    }
  });

  // Fechar sidebar ao clicar em um item do menu (mobile apenas)
  $(document).on('click', '.sidebar-menu a', function(e) {
    if (window.innerWidth <= 767) {
      const $link = $(this);
      const isTreeviewParent = $link.parent('li').hasClass('treeview');

      // Se não é um item pai de submenu (treeview), fecha o sidebar
      // Itens de submenu também fecham o sidebar
      if (!isTreeviewParent || $link.parent('li').hasClass('treeview-menu')) {
        // Pequeno delay para permitir a navegação antes de fechar
        setTimeout(function() {
          $('body').addClass('sidebar-collapse');
          localStorage.setItem('sidebar-collapsed', true);
          $(window).trigger('resize');
        }, 150);
      }
    }
  });

  $(document).on('mouseenter', '.main-sidebar', function() {
    if ($('body').hasClass('sidebar-collapse')) {
      $('body')
        .removeClass('sidebar-collapse')
        .addClass('sidebar-open');
    }
  });

  $(document).on('mouseleave', '.main-sidebar', function() {
    if ($('body').hasClass('sidebar-open')) {
      $('body')
        .removeClass('sidebar-open')
        .addClass('sidebar-collapse');
    }
  });
}
